<template>
  <focus-trap active>
    <div class="modal-window">
      <div class="modal-window-text">
        <h3 id="dialog-title">
          {{ heading }}
        </h3>
        <p v-html="text" tabindex="0" id="dialog-description"></p>
      </div>

      <a
        @click="closeModal"
        @keydown.enter="closeModal"
        v-html="buttonClose"
        aria-label="Close modal"
        class="modal-close-button progress modal-error"
        ref="modalCloseButton"
        role="button"
        tabindex="0"
      ></a>
    </div>
  </focus-trap>
</template>

<script>
import { FocusTrap } from 'focus-trap-vue';
import { mapMutations } from 'vuex';
import btnClose from 'assets/svg/btn-close.svg';

export default {
  components: {
    FocusTrap
  },
  data() {
    return {
      currentTextFocusIndex: null,
      textLength: 0,
      buttonClose: btnClose
    };
  },
  methods: {
    ...mapMutations('application', ['setModal']),
    closeModal() {
      this.setModal(undefined);
    },
    onDialogDescriptionFocusIn(event) {
      if (event.relatedTarget && event.relatedTarget.nodeName === 'SPAN') {
        this.$refs.modalCloseButton.focus();
      }
    },
    onDialogDescriptionKeydown(event) {
      if (event.key === 'ArrowUp' || event.key === 'ArrowRight') {
        if (this.currentTextFocusIndex + 1 === this.textLength) return;

        this.currentTextFocusIndex =
          typeof this.currentTextFocusIndex === 'object' ? 0 : this.currentTextFocusIndex + 1;
        this.modifyDialogDescriptionHtml(this.currentTextFocusIndex);
      }

      if (event.key === 'ArrowDown' || event.key === 'ArrowLeft') {
        if (!this.currentTextFocusIndex) return;
        this.currentTextFocusIndex =
          typeof this.currentTextFocusIndex === 'object' ? 0 : this.currentTextFocusIndex - 1;
        this.modifyDialogDescriptionHtml(this.currentTextFocusIndex);
      }
    },
    modifyDialogDescriptionHtml(charIndex) {
      const dialogDescription = document.getElementById('dialog-description');
      dialogDescription.innerHTML = this.text
        .split('')
        .map((char, index) => {
          if (index === charIndex) {
            return `<span tabindex="0">${char}</span>`;
          }
          return char;
        })
        .join('');
      this.$nextTick(() => {
        const dialogDescriptionSpanEl = document.querySelector('#dialog-description span');
        if (dialogDescriptionSpanEl) {
          dialogDescriptionSpanEl.focus();
        }
      });
    },
    resetDialogDescriptionHtml() {
      const dialogDescription = document.getElementById('dialog-description');
      dialogDescription.innerHTML = this.text;
      this.currentTextFocusIndex = null;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.modalCloseButton.focus();
      this.textLength = this.text.length;
    });
  },
  props: {
    heading: {
      required: true,
      type: String
    },
    text: {
      required: true,
      type: String
    }
  }
};
</script>

<style lang="scss">
.modal-window {
  background-color: white;
  border-radius: 8px;
  height: 404px;
  margin: 0 auto;
  position: relative;
  width: 700px;
}
.modal-window-text {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: flex-start;
  margin: auto;
  padding: 0px !important;
  width: 500px;
  h3 {
    color: black;
    font-family: 'hwtfutura-bold';
    font-size: 20px;
  }
  p {
    color: black;
    font-family: 'hwtfutura';
    font-size: 20px;

    &:focus {
      outline: 5px auto #015fcc !important;
    }

    span {
      color: black;
      font-family: 'hwtfutura';
      font-size: 20px;

      &:focus {
        outline: 5px auto #015fcc !important;
      }
    }
  }
}
.modal-error {
  right: -32px !important;
  top: -32px !important;

  &:focus {
    outline: 5px auto #015fcc;
  }
}
</style>
